import React from 'react';
import { useTranslation } from 'react-i18next';
import { Route, useHistory } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@ge/components/button';
import { globalColors } from '@ge/tokens/colors';

import Ge_Vernova_Logo from './images/ge_vrnv_logo.png';
import LifespanLogo from './images/lifespan_logo.svg';

const StyledLoginContainer = styled.div`
  align-items: center;
  background: ${globalColors.grey};
  display: flex;
  justify-content: center;
  height: 100vh;
  width: 100%;
  position: relative;
`;

const StyledLoginWrapper = styled.div`
  align-items: center;
  background-color: ${globalColors.slate1};
  box-shadow: 0px 8px 16px 0px #00000080;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 318px;
  width: 474px;

  .login-button {
    background-image: linear-gradient(180deg, #006e71 1.04%, #005e60 97.9%);
    border-radius: 4px;
    border: 1px solid #005e60;
    padding: 4px 35px;
  }

  .title {
    color: ${globalColors.grey7};
    margin-bottom: 29px;
  }
`;

const StyledText = styled.p`
  color: ${globalColors.white};
  margin: 0 0 21px 0;
`;

const StyledImg = styled.img`
  margin-bottom: 21px;
  height: 133px;
  width: 242px;
  &.brand-logo {
    position: absolute;
    height: 85px;
    width: 250px;
    bottom: 0;
  }
`;

export const Logout = () => {
  const { t } = useTranslation(['general']);

  const history = useHistory();

  return (
    <Route
      component={() => (
        <StyledLoginContainer>
          <StyledLoginWrapper>
            <StyledImg src={LifespanLogo} alt="Logo" />
            <StyledText className="body-1">
              {t('login_message', 'Sign in with your company SSO for access.')}
            </StyledText>
            <Button className="login-button" type="button" onClick={() => history.push('/')}>
              {t('go_to_sign_in', 'Go to Sign In')}
            </Button>
          </StyledLoginWrapper>
          <StyledImg src={Ge_Vernova_Logo} alt="Logo" className="brand-logo" />
        </StyledLoginContainer>
      )}
    />
  );
};
